import { render, staticRenderFns } from "./GroupIcon.vue?vue&type=template&id=3288fc4d"
import script from "./GroupIcon.vue?vue&type=script&lang=js"
export * from "./GroupIcon.vue?vue&type=script&lang=js"
import style0 from "./GroupIcon.vue?vue&type=style&index=0&id=3288fc4d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports